import { requestJson } from "../http/httpClient";
import { items, project, version } from "./knowledgeDataApi";
import {
  readPublication,
  readReleaseSummary,
  readResearchSpaceProject,
  readResearchSpaceStatus,
  type Publication,
  type ReleaseSummary,
  type ResearchSpaceProject,
  type ResearchSpaceStatus,
} from "./releaseDecoders";

/**
 * Releases and publishing to the installation's one ResearchSpace (`docs/components/knowledge-data.md`
 * K-12, K-13). A release is made in a Thread of the release Workflow (ADR-0026 slice 3b).
 */

/** The project's releases, newest first, each with its newest ResearchSpace publication. */
export function listReleases(projectId: string, signal?: AbortSignal): Promise<ReleaseSummary[]> {
  return requestJson({ method: "GET", path: `${project(projectId)}/releases`, signal, decodeResponse: items(readReleaseSummary) });
}

export function getResearchSpaceStatus(signal?: AbortSignal): Promise<ResearchSpaceStatus> {
  return requestJson({ method: "GET", path: "/knowledge-data/researchspace", signal, decodeResponse: readResearchSpaceStatus });
}

export function getResearchSpaceProject(projectId: string, signal?: AbortSignal): Promise<ResearchSpaceProject> {
  return requestJson({
    method: "GET",
    path: `${project(projectId)}/knowledge-data/researchspace`,
    signal,
    decodeResponse: readResearchSpaceProject,
  });
}

/** Export, regenerate the project's pages and make ResearchSpace use them; the record says how far it came. */
export function publishToResearchSpace(datasetId: string, number: number): Promise<Publication> {
  return requestJson({ method: "POST", path: `${version(datasetId, number)}/researchspace`, decodeResponse: readPublication });
}
